import React, { FC } from "react";

import Profile from "../Profile/Profile";

import { classNames } from "../../../../utils/common/styling";

import { ISidebarWrapper } from "./ISidebarWrapper";
import { styles } from "./SidebarWrapper.styles";

import { DEFAULT_LISTING_IMG_SRC } from "../../../../assets/listings";
import { DEFAULT_CREATOR_THEME } from "../../../../features/Common/modules/Theme/constants/Theme.constants";
import { CreatorThemeContext } from "../../../../features/Common/modules/Theme/CreatorThemeContext";
import { useCreatorThemeContext } from "../../../../features/Common/modules/Theme/CreatorThemeContext";
import { SPLASH_TOP_BANNER } from "../Sidebar.constants";

const SidebarWrapper: FC<ISidebarWrapper.IProps> = ({
  children,
  showDividers: hasDividers = true,
  profileProps,
  className,
  configClassName,
  dividerClassName,
  coverImageClassName,
  showPoweredByExly,
  theme = DEFAULT_CREATOR_THEME,
}) => {
  const { coverImage } = profileProps || {};
  const creatorTheme = useCreatorThemeContext();

  const totalChildrens = Array.isArray(children) ? children.length : 1;

  return (
    <CreatorThemeContext.Provider value={theme}>
      <div className={classNames(styles.root, className)}>
        {/* New background design with curved top */}
        <div className={styles.backgroundContainer}>
          <div
            className={styles.curvedBackground}
            style={{
              backgroundImage: `url(${SPLASH_TOP_BANNER})`,
              backgroundRepeat: "repeat",
              backgroundPosition: "top center",

              backgroundColor:
                creatorTheme?.colors?.color1 ||
                theme?.colors?.color1 ||
                "#493AB1",
            }}
          />

          {/* Content container with card design */}
          <div className={styles.contentContainer}>
            <div className={styles.profileCard}>
              {/* Cover image as card background */}
              <img
                src={coverImage || DEFAULT_LISTING_IMG_SRC}
                alt="cover"
                className={classNames(styles.coverImage, coverImageClassName)}
              />

              {/* Profile content */}
              <div className={styles.profileContent}>
                <Profile
                  {...profileProps}
                  showPoweredByExly={showPoweredByExly}
                />
              </div>
            </div>

            {/* Navigation sections */}
            <div className={classNames(styles.config, configClassName)}>
              {hasDividers
                ? React.Children.map(
                    children,
                    (children: React.ReactNode & { key: string }, index) => (
                      <React.Fragment key={children.key}>
                        {children}
                        {index < totalChildrens - 1 && (
                          <hr
                            className={classNames(
                              styles.divider,
                              dividerClassName,
                            )}
                          />
                        )}
                      </React.Fragment>
                    ),
                  )
                : children}
            </div>
          </div>
        </div>
      </div>
    </CreatorThemeContext.Provider>
  );
};

export default SidebarWrapper;
